import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const MissionServicesInfoForm_ServiceUsage_MoveToGroup_Mutation =
  graphql(`
    mutation MissionServicesInfoForm_ServiceUsage_MoveToGroup(
      $serviceUsageId: Id!
      $serviceUserId: Id!
      $targetServiceUsagesGroupId: Id!
      $versionData: VersionDataInput
    ) {
      moveMissionServiceUsageToGroup(
        serviceUsageId: $serviceUsageId
        serviceUserId: $serviceUserId
        targetServiceUsagesGroupId: $targetServiceUsagesGroupId
        versionData: $versionData
      ) {
        _id
      }
    }
  `);

export const useMoveMissionServiceUsageToGroupMutation = () =>
  useGraphQLMutation(MissionServicesInfoForm_ServiceUsage_MoveToGroup_Mutation);
